export const DIAGNOSTIC_LEVEL = [0, 1, 2, 3] as const;

export const DIAGNOSTIC_LEVEL_STRING = [
  'normal',
  'warning',
  'error',
  'stale',
] as const;
